import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import CardIconView from '../../components/common/CardIconView'
import { getUserSiteDashboardApi } from '../../utils/ApiEndpointFunctions'
import toast from 'react-hot-toast'
import { formatPrice } from '../../utils/HelperFuncitons'
import Spinwheel from '../../components/common/Spinwheel'

export default function DashboardView({ details, loading }) {
   const formatDays = value => Number.isFinite(value) ? `${value} day${value === 1 ? "" : "s"}` : "Not configured";
   const pendingTime = details?.contract?.overdueDays > 0
      ? `Overdue by ${formatDays(details.contract.overdueDays)}`
      : formatDays(details?.contract?.timePendingDays);
   // const [details,setDetails] = useState(null)
   // const [loading,setLoading] = useState(true)


   // const getDashboardDetails = async () => {
   //    alert("")
   //    console.log("------------------", timeZone)
   //    setLoading(true)
   //    try {
   //       const res = await getUserSiteDashboardApi()
   //       if (res.status === 200) {
   //          setDetails(res.data?.data?.[0]);
   //          setLoading(false)
   //       }
   //    } catch (err) {
   //       console.log(err)
   //       if (err.response && err.response.data) {
   //          toast.error(err.response.data.message)
   //        } else {
   //          toast.error("Something went wrong")
    
   //        }
   //    }
   // }

//   useEffect(() => {
//       getDashboardDetails()
//   }, [timeZone])

   return (
      <div>
         <div class="container-fluid" bis_skin_checked="1">
            {loading ? <div className='d-flex justify-content-center align-items-center'> <Spinwheel /> </div> : <div class=" mt-4" bis_skin_checked="1">

               
               <div class="card ps-3 mt-2" bis_skin_checked="1">
                  <div class="p-4 pb-0" bis_skin_checked="1">
                     <h3>Notification</h3>
                     <div className='d-flex'>
                        <div class="p-2" bis_skin_checked="1">
                           <Link to="/notification" style={{ textDecoration: 'none', color: 'inherit' }}>
                              <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                 <CardIconView style={{}} iconSrc={"https://img.icons8.com/fluency/48/appointment-reminders--v1.png"} />
                                 <div class="flex-grow-1" bis_skin_checked="1">
                                    <span class="mb-1">Low Inventory Notification</span>
                                    <h5 class="fw-bold fs-5 p-0">{details?.unAckNotification || 0}</h5>
                                 </div>
                              </div>
                           </Link>
                        </div>
                        <div class="p-2" bis_skin_checked="1">
                           <Link to="/purchase" style={{ textDecoration: 'none', color: 'inherit' }}>
                              <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                 <CardIconView style={{}} iconSrc={"https://img.icons8.com/fluency/48/appointment-reminders--v1.png"} />
                                 <div class="flex-grow-1" bis_skin_checked="1">
                                    <span class="mb-1"> Pending approval of PO</span>
                                    <h5 class="fw-bold fs-5 p-0">{details?.poApproval?.[0]?.count || 0}</h5>
                                 </div>
                              </div>
                           </Link>
                        </div>
                        <div class="p-2" bis_skin_checked="1">
                           <Link to="/challan" style={{ textDecoration: 'none', color: 'inherit' }}>
                              <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                 <CardIconView style={{}} iconSrc={"https://img.icons8.com/fluency/48/appointment-reminders--v1.png"} />
                                 <div class="flex-grow-1" bis_skin_checked="1">
                                    <span class="mb-1"> Pending approval of Challan</span>
                                    <h5 class="fw-bold fs-5 p-0">{details?.challanApproval?.[0]?.count || 0}</h5>
                                 </div>
                              </div>
                           </Link>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="card ps-3 mt-2" bis_skin_checked="1">
                  <div class="p-4 pb-0" bis_skin_checked="1">
                     <h3>Tracker</h3>
                     <div class="row row-cols-1 row-cols-md-2" bis_skin_checked="1">
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Work Tracker</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <Link to="/boq" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Total Amount of BOQ</p>
                                          <h5 class="fw-bold fs-5 ">{formatPrice(details?.boqSummary?.amount || 0)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                       </div>
                                    </Link>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Time Allocated</p>
                                          <h5 class="fw-bold fs-5 ">{formatDays(details?.contract?.timeAllocatedDays)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Time Consumed</p>
                                          <h5 class="fw-bold fs-5 ">{formatDays(details?.contract?.timeConsumedDays)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Time Pending</p>
                                          <h5 class="fw-bold fs-5 ">{pendingTime}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Financial Tracker</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Total Contract Amount</p>
                                          <h5 class="fw-bold fs-5 ">{formatPrice(details?.boqSummary?.adjustedAmount || 0)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Total Work Done Amount</p>
                                          <h5 class="fw-bold fs-5 ">{formatPrice(details?.billingSummary?.totalBillingAmount || 0)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Pending Approval Amount</p>
                                          <h5 class="fw-bold fs-5 ">{formatPrice(details?.billingSummary?.awaitingApprovalAmount || 0)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" bis_skin_checked="1">
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Pending Amount for Billing</p>
                                          <h5 class="fw-bold fs-5 ">{formatPrice(details?.billingSummary?.pendingForBillingAmount || 0)}</h5>
                                       </div>
                                       <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               {/*  tracker section end */}
               <div class="card ps-3 mt-2" bis_skin_checked="1">
                  <div class="p-4 pb-0" bis_skin_checked="1">
                     <h3>POs</h3>
                     <div class="row row-cols-1 row-cols-md-2" bis_skin_checked="1">
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Vendor</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <Link to="/purchase" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center justify-content-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: '#65ff65' }} iconSrc={'/purchase_order.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Approved Amt</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.po?.find(ele=>ele?.type?.toLowerCase()=="vendor" && ele?.status?.toLowerCase()=="approved")?.totalAmount || 0)}</h5>
                                       </div>
                                       </div>
                                    </Link>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <Link to="/purchase" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: 'yellow' }} iconSrc={'/purchase_order.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Submitted Amt</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.po?.find(ele=>ele?.type?.toLowerCase()=="vendor" && ele?.status?.toLowerCase()=="submitted")?.totalAmount || 0)}</h5>
                                       </div>
                                       </div>
                                    </Link>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Subcontractor</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <Link to="/purchase" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center justify-content-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <CardIconView style={{ backgroundColor: '#65ff65' }} iconSrc={'/purchase_order.png'} />
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Approved Amt</p>
                                             <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.po?.find(ele=>ele?.type?.toLowerCase()=="sub-contractor" && ele?.status?.toLowerCase()=="approved")?.totalAmount || 0)}</h5>
                                          </div>
                                       </div>
                                    </Link>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <Link to="/purchase" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <CardIconView style={{ backgroundColor: 'yellow' }} iconSrc={'/purchase_order.png'} />
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Submitted Amt</p>
                                             <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.po?.find(ele=>ele?.type?.toLowerCase()=="sub-contractor" && ele?.status?.toLowerCase()=="submitted")?.totalAmount || 0)}</h5>
                                          </div>
                                       </div>
                                    </Link>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className='row row-cols-1 row-cols-md-2'>
                  <div className='p-2'>
                     <div class="card ps-3 mt-2" bis_skin_checked="1">
                        <div class="p-4 pb-0" bis_skin_checked="1">
                           <h3>Challan (vendor)</h3>
                           <div class="row row-cols-2 mt-3" bis_skin_checked="1">
                              <div className='p-2'>
                                 <Link to="/challan" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center justify-content-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: '#65ff65' }} iconSrc={'/challan.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Approved Amt</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.challan?.find(ele=>ele?.type?.toLowerCase()=="vendor" && ele?.status?.toLowerCase()=="approved")?.totalAmount || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                              <div className='p-2' bis_skin_checked="1">
                                 <Link to="/challan" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: 'yellow' }} iconSrc={'/challan.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Submitted Amt</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.challan?.find(ele=>ele?.type?.toLowerCase()=="vendor" && ele?.status?.toLowerCase()=="submitted")?.totalAmount || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className='p-2'>
                     <div class="card ps-3 mt-2" bis_skin_checked="1">
                        <div class="p-4 pb-0" bis_skin_checked="1">
                           <h3>Daily Cashbook</h3>
                           <div class="row row-cols-2 mt-3" bis_skin_checked="1">
                              <div className='p-2'>
                                 <Link to="/cashbook" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center justify-content-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: '#65ff65' }} iconSrc={'/my_cashbook.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Amount at start of the day</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.vouchers?.lastBalance?.siteBalance || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                              <div className='p-2' bis_skin_checked="1">
                                 <Link to="/cashbook" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: 'yellow' }} iconSrc={'/my_cashbook.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Current Balance</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.vouchers?.currentBalance?.siteBalance || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                              <div className='p-2' bis_skin_checked="1">
                                 <Link to="/cashbook" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: 'rgb(255 164 101)' }} iconSrc={'/my_cashbook.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Amount Consumed</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.vouchers?.todayOutward?.outward || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                              <div className='p-2' bis_skin_checked="1">
                                 <Link to="/cashbook" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <div class="card shadow-lg border-0 rounded-3 p-3 d-flex gap-3 flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                       <CardIconView style={{ backgroundColor: 'rgb(255 164 101)' }} iconSrc={'/my_cashbook.png'} />
                                       <div class="flex-grow-1" bis_skin_checked="1">
                                          <p class="text-muted mb-1">Total Expenditure</p>
                                          <h5 class="fw-bold fs-5 p-0">{formatPrice(details?.vouchers?.totalOutward?.outward || 0)}</h5>
                                       </div>
                                    </div>
                                 </Link>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>


               {/* labour section start */}
               <div class="card ps-3 mt-2" bis_skin_checked="1">
                  <div class="p-4 pb-0" bis_skin_checked="1">
                     <h3>Labour count</h3>
                     <div class="row row-cols-1 row-cols-md-2" bis_skin_checked="1">
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Tech</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <Link to="/dlr" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Yesterday</p>
                                             <h5 class="fw-bold fs-5 ">{details?.dlr?.yesterdayLabour?.totalTechnical || 0}</h5>
                                          </div>
                                          <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                       </div>
                                    </Link>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <Link to="/dlr" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Today</p>
                                             <h5 class="fw-bold fs-5 ">{details?.dlr?.todayLabour?.totalTechnical || 0}</h5>
                                          </div>
                                          <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                       </div>
                                    </Link>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="p-2" bis_skin_checked="1">
                           <div class="border-primary border rounded-3 p-4 mt-2" bis_skin_checked="1">
                              <h3>Non-Tech</h3>
                              <div class="row row-cols-1 row-cols-md-2 mt-3" bis_skin_checked="1">
                                 <div className='p-2'>
                                    <Link to="/dlr" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Yesterday</p>
                                             <h5 class="fw-bold fs-5 ">{details?.dlr?.yesterdayLabour?.totalNonTechnical || 0}</h5>
                                          </div>
                                          <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                       </div>
                                    </Link>
                                 </div>
                                 <div className='p-2' bis_skin_checked="1">
                                    <Link to="/dlr" style={{ textDecoration: 'none', color: 'inherit' }}>
                                       <div class="card shadow-lg border-0 rounded-3 p-3 d-flex flex-row align-items-center" style={{ cursor: 'pointer', color: 'inherit' }} bis_skin_checked="1">
                                          <div class="flex-grow-1" bis_skin_checked="1">
                                             <p class="text-muted mb-1">Today</p>
                                             <h5 class="fw-bold fs-5 ">{details?.dlr?.todayLabour?.totalNonTechnical || 0}</h5>
                                          </div>
                                          <div class="icon-box bg-primary text-white p-3 rounded-circle" bis_skin_checked="1"><i class="bi bi-activity"></i></div>
                                       </div>
                                    </Link>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               {/*  labour section end */}

            </div>}
            
         </div>
      </div>
   )
}
